export default __webpack_public_path__ + "static/media/Cisco_logo.b8c4d45e.svg";